// DS: i4.75
import React, { useId } from 'react';
import c from 'classnames';
import IconWrap, { Props as WrapperProps } from '../../IconWrap';

import s from './Supporters.scss';

export interface Props extends WrapperProps {
  withGradient?: boolean;
}

const Supporters: React.FC<Props> = props => {
  const { withGradient, ...rest } = props;
  const gradientIdPrefix = useId();
  return (
    <span
      className={c(withGradient && s['with-gradient'])}
      style={
        withGradient
          ? {
              clipPath: `url(#${gradientIdPrefix}-0)`,
            }
          : undefined
      }
    >
      <IconWrap {...rest}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <clipPath id={`${gradientIdPrefix}-0`}>
              <path
                d="M6.82655 3.41996L7.35977 3.30005L7.45421 3.83825C7.55738 4.42627 7.4753 4.98683 7.17329 5.47358C6.92959 5.86612 5.96702 6.36771 5.48483 6.52835L5.04306 6.67553L4.99562 6.21256C4.93592 5.63005 4.93463 4.83011 5.3043 4.34659C5.79122 3.71012 6.50837 3.49151 6.82655 3.41996Z"
                fill="currentColor"
              />
              <path
                d="M1.70962 9.4437L1.77336 9.05693L2.15672 9.14008C3.48646 9.42848 4.17007 10.5369 4.08551 11.8422L4.04351 12.4905L3.41929 12.3077C2.02538 11.8997 1.48034 10.8349 1.70962 9.4437Z"
                fill="currentColor"
              />
              <path
                d="M2.71493 5.38202L2.50466 5.88593C2.37919 6.18662 2.14319 6.89748 2.38125 7.66223C2.56224 8.24302 3.21584 8.70434 3.72575 8.9924L4.131 9.22133L4.26617 8.7762C4.41371 8.29035 4.56059 7.21588 4.38105 6.79035C4.15832 6.26285 3.74826 5.87193 3.20875 5.61614L2.71493 5.38202Z"
                fill="currentColor"
              />
              <path
                d="M3.23096 16.5716C3.7407 16.2584 4.29176 16.1303 4.85548 16.2305C5.71775 16.3846 6.33407 17.0275 6.57541 17.3128L6.99595 17.8099L6.41774 18.11C5.78425 18.4388 5.13107 18.5544 4.50394 18.3804C3.73244 18.1651 3.26015 17.5782 3.07493 17.3096L2.76393 16.8586L3.23096 16.5716Z"
                fill="currentColor"
              />
              <path
                d="M9.12863 19.1251C8.82132 18.9143 8.05603 18.454 7.1831 18.5351C6.61237 18.5867 6.11507 18.8572 5.70706 19.2924L5.33203 19.6924L5.75158 20.0456C6.00114 20.2557 6.61216 20.6973 7.41305 20.7015L7.41492 20.7016L7.42385 20.7016C8.07236 20.7016 8.66698 20.4166 9.18748 19.9355L9.66574 19.4935L9.12863 19.1251Z"
                fill="currentColor"
              />
              <path
                d="M2.03951 12.9774C2.62688 12.8718 3.18807 12.951 3.67697 13.2504C4.42372 13.7073 4.76275 14.5295 4.88339 14.8832L5.09377 15.4999L4.44503 15.5682C3.73593 15.6428 3.08611 15.5164 2.56427 15.1248C1.92447 14.6439 1.69881 13.9252 1.62456 13.6075L1.5 13.0743L2.03951 12.9774Z"
                fill="currentColor"
              />
              <path
                d="M17.1733 3.41996L16.6401 3.30005L16.5457 3.83825C16.4425 4.42627 16.5246 4.98683 16.8266 5.47358C17.0703 5.86612 18.0329 6.36771 18.515 6.52835L18.9568 6.67553L19.0043 6.21256C19.0639 5.63005 19.0652 4.83011 18.6956 4.34659C18.2087 3.71012 17.4915 3.49151 17.1733 3.41996Z"
                fill="currentColor"
              />
              <path
                d="M22.2903 9.4437L22.2265 9.05693L21.8432 9.14008C20.5134 9.42848 19.8298 10.5369 19.9144 11.8422L19.9564 12.4905L20.5806 12.3077C21.9745 11.8997 22.5195 10.8349 22.2903 9.4437Z"
                fill="currentColor"
              />
              <path
                d="M21.2849 5.38202L21.4952 5.88593C21.6207 6.18662 21.8567 6.89748 21.6186 7.66223C21.4376 8.24302 20.784 8.70434 20.2741 8.9924L19.8689 9.22133L19.7337 8.7762C19.5862 8.29035 19.4393 7.21588 19.6188 6.79035C19.8415 6.26285 20.2516 5.87193 20.7911 5.61614L21.2849 5.38202Z"
                fill="currentColor"
              />
              <path
                d="M20.7689 16.5716C20.2592 16.2584 19.7081 16.1303 19.1444 16.2305C18.2821 16.3846 17.6658 17.0275 17.4245 17.3128L17.0039 17.8099L17.5821 18.11C18.2156 18.4388 18.8688 18.5544 19.4959 18.3804C20.2674 18.1651 20.7397 17.5782 20.9249 17.3096L21.2359 16.8586L20.7689 16.5716Z"
                fill="currentColor"
              />
              <path
                d="M14.8712 19.1251C15.1786 18.9143 15.9438 18.454 16.8168 18.5351C17.3875 18.5867 17.8848 18.8572 18.2928 19.2924L18.6678 19.6924L18.2483 20.0456C17.9987 20.2557 17.3877 20.6973 16.5868 20.7015L16.585 20.7016L16.576 20.7016C15.9275 20.7016 15.3329 20.4166 14.8124 19.9355L14.3341 19.4935L14.8712 19.1251Z"
                fill="currentColor"
              />
              <path
                d="M21.9604 12.9774C21.373 12.8718 20.8118 12.951 20.3229 13.2504C19.5762 13.7073 19.2371 14.5295 19.1165 14.8832L18.9061 15.4999L19.5548 15.5682C20.2639 15.6428 20.9138 15.5164 21.4356 15.1248C22.0754 14.6439 22.3011 13.9252 22.3753 13.6075L22.4999 13.0743L21.9604 12.9774Z"
                fill="currentColor"
              />
              <path
                d="M7.63981 12.381C6.66058 11.3917 6.65963 9.80126 7.63981 8.81294C8.61999 7.82457 10.1982 7.82457 11.1784 8.81294L11.9826 9.62385L12.7818 8.81799C13.762 7.82959 15.3402 7.82961 16.3203 8.81799C17.3005 9.80637 17.3005 11.3977 16.3203 12.386L11.9776 16.7651L7.63981 12.381Z"
                fill="currentColor"
              />
            </clipPath>
          </g>
        </svg>
      </IconWrap>
    </span>
  );
};
Supporters.displayName = 'Supporters';

export default Supporters;
